exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".newsBox[data-v-5f6c9500] {\n  background-color: #fafafa;\n  overflow: hidden;\n  position: relative;\n}\n.newsBox .bannerBox[data-v-5f6c9500] {\n    width: 1200px;\n    height: 340px;\n    margin-top: 20px;\n}\n", ""]);

